import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { Panel, PanelSidebar, PanelRightColumn, PanelBody, PanelControls } from '../panel'
import { getVehiclesCount } from '../ducks/vehicles.js'

import VehiclesPrompt from './vehicles_prompt.jsx'
import VehiclesForm from './vehicles_form.jsx'
import VehiclesHeader from './vehicles_header.jsx'

class VehiclesNew extends React.Component {
  constructor(props) {
    super(props)

    this.state = { incidentReport: { wereAnyVehiclesInvolved: this.props.wereAnyVehiclesInvolved } }
  }

  renderState = () => {
    if (this.props.vehiclesCount === 0 && !this.state.incidentReport.wereAnyVehiclesInvolved) {
      return "prompt"
    }
    else if (this.props.vehiclesCount === 0 && this.state.incidentReport.wereAnyVehiclesInvolved) {
      return "prompt_with_form"
    }
    else {
      return "form"
    }
  }

  toggleWereAnyVehiclesInvolved = (value) => {
    this.setState((prevState, props) => ({
      incidentReport: { ...prevState.incidentReport, wereAnyVehiclesInvolved: value }
    }))
  }

  render() {
    switch (this.renderState()) {
      case "prompt": {
        return (
          <Panel>
            <PanelSidebar />

            <PanelRightColumn>
              <PanelBody>
                <VehiclesHeader />

                <div className="row">
                  <div className="col-xs-12">
                    <VehiclesPrompt onChange={ this.toggleWereAnyVehiclesInvolved }
                                    value={ this.state.incidentReport.wereAnyVehiclesInvolved } />
                  </div>
                </div>
              </PanelBody>

              <PanelControls>
                <Link to="/persons">
                  <button type="button"
                          className="btn btn-link">

                    Back
                  </button>
                </Link>

                <Link to="/properties">
                  <button type="button"
                          className="btn btn-success">

                    Next
                  </button>
                </Link>
              </PanelControls>
            </PanelRightColumn>
          </Panel>
        )
      }

      case "prompt_with_form": {
        return <VehiclesForm withPrompt
                             promptValue={ this.state.incidentReport.wereAnyVehiclesInvolved }
                             onPromptChange={ this.toggleWereAnyVehiclesInvolved }
                             incidentReport={{ ...this.state.incidentReport }} />
      }

      default: {
        return <VehiclesForm />
      }
    }
  }
}

VehiclesNew = connect(
  (state, props) => ({
    vehiclesCount: getVehiclesCount(state.vehicles),
    wereAnyVehiclesInvolved: state.incidentReport.wereAnyVehiclesInvolved
  })
)(VehiclesNew);

export default VehiclesNew
